import decodeJwt from 'jwt-decode';
import auth0 from 'auth0-js';

const webAuth = new auth0.WebAuth({
  domain: process.env.AUTH0_DOMAIN,
  clientID: process.env.AUTH0_CLIENT_ID
});

function renewAuth(opts = {}) {
  return new Promise((resolve, reject) => {
    webAuth.renewAuth(opts, (err, authResult) => {
      if (err) {
        reject(err);
      } else {
        resolve(authResult);
      }
    });
  });
}

function tokenIsExpired(token) {
  const tokenExpirationTime = decodeJwt(token).exp;
  const currentTime = Math.ceil(Date.now() / 1000);
  return tokenExpirationTime < currentTime;
}

const lastUriKey = 'redirectUriAfterLogin';
function getRedirectUri() {
  return localStorage.getItem(lastUriKey) || '/';
}
function setRedirectUri() {
  const redirectUri = window.location.pathname;
  localStorage.setItem(lastUriKey, redirectUri);
}
function removeRedirectUriFromStorage() {
  localStorage.removeItem(lastUriKey);
}

function redirectToLogin() {
  setRedirectUri();
  window.location = '/logout';
}

async function getIdToken() {
  const authOptions = {
    scope: 'openid email user_metadata app_metadata picture profile',
    redirectUri: `${window.location.origin}/static/authSilentCallback.html`,
    nonce: 'stitch-renewAuth',
    usePostMessage: true,
    postMessageDataType: 'auth0:silent-authentication'
  };
  const idTokenKey = 'id_token';
  let idToken = localStorage.getItem(idTokenKey);

  if (idToken && tokenIsExpired(idToken)) {
    try {
      const authResult = await renewAuth(authOptions);
      idToken = authResult.idToken;
      if (idToken) {
        localStorage.setItem(idTokenKey, idToken);
      } else {
        // The renewAuth method failed due to someone else closing the iframe.
        // Maybe some extension like Augury or VueDevtools caused the issue.
        // See: https://github.com/auth0/auth0.js/issues/406
        console.error('Refreshing the token failed due to someone else closing the iframe');
        redirectToLogin();
      }
    } catch (e) {
      console.error('Refreshing the token failed due to an error response ', e);
      redirectToLogin();
    }
  }
  return idToken;
}

function singleExec(fn) {
  let lock;
  return async function () {
    lock = lock || fn();
    const r = await lock;
    lock = undefined;
    return r;
  };
}

export default {
  getIdToken: singleExec(getIdToken),
  getRedirectUri,
  removeRedirectUriFromStorage
};



// WEBPACK FOOTER //
// ./src/services/authService.js